var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Agitavit;
(function (Agitavit) {
    var DynamicForm;
    (function (DynamicForm) {
        var FormRenderer = /** @class */ (function () {
            function FormRenderer() {
            }
            FormRenderer.RenderFormField = function (target, formField, state, model, labelClasses, controlClasses, fieldClass, ctrlClass) {
                state = { ...state, IsHidden: formField.IsHidden }

                var $form = $(target.closest("form"));
                var formControls = $form.data("agControls") || {};
                $form.data("agControls", formControls);

                var _a, _b;
                // element root node
                var element = document.createElement("div");
                element.classList.add("ag-form-element", "ag-field", "ag-field-" + (state.IsReadonly ? "display" : "editor"), "ag-form-field");
                if (fieldClass) {
                    const fieldClasses = fieldClass.trim().split(" ");
                    fieldClasses.forEach(fc => {
                        fc.trim();
                        element.classList.add(fc);
                    });
                }
                element.dataset.basename = formField.ElementBaseName;
                if (formField.IsHidden) {
                    element.classList.add("ag-hidden");
                }
                // form group (&validation) root node
                var formGroup = document.createElement("div");
                formGroup.classList.add("form-group", "validation-node");
                if (!formField.LabelTop) {
                    formGroup.classList.add("form-group-flex");
                }
                element.appendChild(formGroup);
                // label
                var label = document.createElement("label");
                label.htmlFor = "DynamicData." + formField.ElementBaseName;
                (_a = label.classList).add.apply(_a, __spreadArrays(["form-label"], labelClasses));
                label.textContent = formField.ElementDisplayName;
                formGroup.appendChild(label);
                // tooltip
                if (formField.Tooltip) {
                    var icon = document.createElement("i");
                    icon.classList.add("ph", "ph-question");
                    icon.style.paddingLeft = "3px";
                    $(icon).uitooltip({
                        classes: {
                            "ui-tooltip-content": "ag-tooltip-content", "ui-tooltip": "ag-tooltip-content"
                        },
                        content: formField.Tooltip,
                        items: "i"
                    });
                    label.appendChild(icon);
                }
                // control
                var controlWrapper = document.createElement("div");
                (_b = controlWrapper.classList).add.apply(_b, controlClasses);
                formGroup.appendChild(controlWrapper);
                target.appendChild(element); // tODO: modify controls to work on non-bound HTML elements

                if (typeof ctrlClass !== "function") {
                    // load control, then initialize
                    return formControls[formField.ElementBaseName] = Promise.resolve()
                        .then(() => Promise.resolve(window.agApp).then(() => importShim(`hrm-controls/${formField.ElementJavascriptControl}`)).then(x => x.default))
                        .then(async (ctrl) => {
                            var control = new ctrl(controlWrapper, model, state, "DynamicData." + formField.ElementBaseName);
                            $(element).data("agControl", control);

                            return formControls[formField.ElementBaseName] = control;
                        });
                }
                else {
                    // control instance was already provided, just use it for initialization
                    var control = new ctrlClass(controlWrapper, model, state, "DynamicData." + formField.ElementBaseName);
                    $(element).data("agControl", control);

                    return Promise.resolve(formControls[formField.ElementBaseName] = control);
                }
            };
            return FormRenderer;
        }());
        DynamicForm.FormRenderer = FormRenderer;
    })(DynamicForm = Agitavit.DynamicForm || (Agitavit.DynamicForm = {}));
})(Agitavit || (Agitavit = {}));
//# sourceMappingURL=FormRenderer.js.map